import { z } from 'zod';

export const zodMaskedStringFactory = ({
  visibleCharacters = 4,
  separator = ' ',
}: {
  visibleCharacters?: number;
  separator?: string | null;
} = {}) =>
  z
    .string()
    .transform((value) => {
      if (value) {
        return `••••${separator ?? ''}${value.trim().slice(-visibleCharacters)}`;
      }
    })
    .meta({ override: { type: 'string' } })
    .brand('zod_masked_string');

export const zodMaskedString = z
  .string()
  .refine((value) => value.startsWith('••••'), 'must be masked')
  .brand('zod_masked_string');

export type MaskedString = z.infer<typeof zodMaskedString>;
